
import { commonTranslations, CommonTranslationKey } from './common';
import { navigationTranslations, NavigationTranslationKey } from './navigation';
import { homeTranslations, HomeTranslationKey } from './home';
import { footerTranslations, FooterTranslationKey } from './footer';
import { authTranslations, AuthTranslationKey } from './auth';
import { dashboardTranslations, DashboardTranslationKey } from './dashboard';
import { channelsTranslations, ChannelsTranslationKey } from './channels';
import { playlistsTranslations, PlaylistsTranslationKey } from './playlists';
import { clipsTranslations, ClipsTranslationKey } from './clips';
import { createDerivativeTranslations, CreateDerivativeTranslationKey } from './createDerivative';
import { exploreTranslations, ExploreTranslationKey } from './explore';
import { licenseTranslations, LicenseTranslationKey } from './license';
import { adminTranslations, AdminTranslationKey } from './admin';
import { derivativesTranslations, DerivativesTranslationKey } from './derivatives';
import { errorsTranslations, ErrorsTranslationKey } from './errors';
import { creatorsTranslations, CreatorsTranslationKey } from './creators';
import { creatorTranslations, CreatorTranslationKey } from './creator';
import { TranslationsByLanguage, Language, PluralTranslation } from './types';

export type TranslationKey =
  | CommonTranslationKey
  | NavigationTranslationKey
  | HomeTranslationKey
  | FooterTranslationKey
  | AuthTranslationKey
  | DashboardTranslationKey
  | ChannelsTranslationKey
  | PlaylistsTranslationKey
  | ClipsTranslationKey
  | CreateDerivativeTranslationKey
  | ExploreTranslationKey
  | LicenseTranslationKey
  | AdminTranslationKey
  | DerivativesTranslationKey
  | ErrorsTranslationKey
  | CreatorsTranslationKey
  | CreatorTranslationKey;

// Fix the re-exporting type issue
export type { Language, PluralTranslation };

// Flatten all translations to avoid nested objects that cause type errors
export const translations: TranslationsByLanguage = {
  en: {
    ...commonTranslations.en,
    ...navigationTranslations.en,
    ...homeTranslations.en,
    ...footerTranslations.en,
    ...authTranslations.en,
    ...dashboardTranslations.en,
    ...channelsTranslations.en,
    ...playlistsTranslations.en,
    ...clipsTranslations.en,
    ...createDerivativeTranslations.en,
    ...exploreTranslations.en,
    ...licenseTranslations.en,
    ...adminTranslations.en,
    ...derivativesTranslations.en,
    ...errorsTranslations.en,
    ...creatorsTranslations.en,
    ...creatorTranslations.en,
  },
  fr: {
    ...commonTranslations.fr,
    ...navigationTranslations.fr,
    ...homeTranslations.fr,
    ...footerTranslations.fr,
    ...authTranslations.fr,
    ...dashboardTranslations.fr,
    ...channelsTranslations.fr,
    ...playlistsTranslations.fr,
    ...clipsTranslations.fr,
    ...createDerivativeTranslations.fr,
    ...exploreTranslations.fr,
    ...licenseTranslations.fr,
    ...adminTranslations.fr,
    ...derivativesTranslations.fr,
    ...errorsTranslations.fr,
    ...creatorsTranslations.fr,
    ...creatorTranslations.fr,
  },
};
